export default function buildGetUserProducerData({
    apiEndpoint,
    apiTools
}) {
    return async function getUserProducerData(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/user`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });
        return await res.json();
    }
}